<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} dịch vụ du lịch chất lượng cao</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} dịch vụ du lịch chất lượng cao</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} dịch vụ du lịch chất lượng cao</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item label="Tên dịch vụ (Tiếng Việt)" prop="ten.vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Tên dịch vụ (Tiếng Anh)" prop="ten.en">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.en"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="2">
              <el-form-item label="Thứ tự" prop="thu_tu">
                <el-input
                  type="number"
                  v-model="mData.dataForm.thu_tu"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label=" " prop="ghim">
                <el-checkbox
                  v-model="mData.dataForm.ghim"
                  :disabled="mData.viewMode == 'detail'"
                >Ghim dịch vụ</el-checkbox>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label=" " prop="an_dich_vu">
                <el-checkbox
                  v-model="mData.dataForm.an_dich_vu"
                  :disabled="mData.viewMode == 'detail'||aRole('HqsContributor')"
                >Ẩn dịch vụ</el-checkbox>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Trạng thái duyệt" prop="da_duyet">
                <el-checkbox
                  v-model="mData.dataForm.da_duyet"
                  @change="fn_changeTrangThaiDuyet(mData.dataForm.da_duyet)"
                  :disabled="mData.viewMode == 'detail' || !aRole('Admin,Officer,HqsManager')"
                >Duyệt/ Chưa duyệt</el-checkbox>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Lý do không duyệt" prop="ly_do_khong_duyet">
                <el-input
                  type="textarea"
                  :rows="1"
                  v-model="mData.dataForm.ly_do_khong_duyet"
                  :disabled="mData.viewMode == 'detail' || mData.dataForm.da_duyet || !aRole('Admin,Officer,HqsManager')"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung (Tiếng Việt)" prop="noi_dung.vi">
                <editor-component
                  :prop-data-editor="mData.dataForm.noi_dung"
                  :prop-data-editor-key="'vi'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung (Tiếng Anh)" prop="noi_dung.en">
                <editor-component
                  :prop-data-editor="mData.dataForm.noi_dung"
                  :prop-data-editor-key="'en'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Địa điểm
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDiaDiem
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaDiem" visible>
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col md="4">
                          <el-form-item label="Tỉnh/Thành phố" prop="dia_diem.province_id">
                            <el-select
                              v-model="mData.dataForm.dia_diem.province_id"
                              placeholder="Chọn tỉnh/thành phố"
                              @change="fn_changeProvince()"
                              clearable
                              filterable
                              :disabled="mData.viewMode == 'detail'"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listProvince"
                                :key="item.id"
                                :value="item.id"
                                :label="item.type + ' ' + item.name"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="4">
                          <el-form-item label="Quận/huyện" prop="dia_diem.district_id">
                            <el-select
                              v-model="mData.dataForm.dia_diem.district_id"
                              placeholder="Chọn quận huyện"
                              no-data-text="Không có dữ liệu"
                              clearable
                              filterable
                              :disabled="mData.viewMode == 'detail'"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listDistrict"
                                :key="item.id"
                                :value="item.id"
                                :label="item.type + ' ' + item.name"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="4">
                          <el-form-item label="Địa chỉ" prop="dia_diem.dia_diem">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.dia_diem.dia_diem"
                              placeholder="Nhập địa chỉ"
                              :disabled="mData.viewMode == 'detail'"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-checkbox
                            v-model="mData.dataPropMap.showMap"
                            :disabled="mData.viewMode == 'detail'"
                          >Địa điểm trên bản đồ</el-checkbox>
                        </b-col>
                        <b-col md="12">
                          <map-component
                            :prop-data-map="mData.dataPropMap"
                            v-if="mData.dataPropMap.showMap"
                            :prop-disabled="mData.viewMode == 'detail'"
                            :key="mData.dataPropMap.reload"
                          ></map-component>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Ảnh dịch vụ
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseAnh
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseAnh" visible>
                  <b-row>
                    <b-col md="4">
                      <el-form-item class="mb-0" label="Ảnh đại diện">
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhDaiDien.limit"
                          :accept="mData.fileUploadOption.AnhDaiDien.accept"
                          :on-change="fn_uploadChangeAnhDaiDien"
                          :on-preview="fn_uploadPreviewAnhDaiDien"
                          :on-remove="fn_uploadRemoveAnhDaiDien"
                          :on-exceed="fn_uploadExceedAnhDaiDien"
                          :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                          :disabled="mData.viewMode == 'detail'"
                          :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                    <b-col md="8">
                      <el-form-item class="mb-0" label="Ảnh bài viết">
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhBaiViet.limit"
                          :accept="mData.fileUploadOption.AnhBaiViet.accept"
                          :on-change="fn_uploadChangeAnhBaiViet"
                          :on-preview="fn_uploadPreviewAnhBaiViet"
                          :on-remove="fn_uploadRemoveAnhBaiViet"
                          :on-exceed="fn_uploadExceedAnhBaiViet"
                          multiple
                          :file-list="mData.fileUploadOption.AnhBaiViet.fileList"
                          :disabled="mData.viewMode == 'detail'"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhBaiViet.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhBaiViet.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DichVuChatLuongCaoModel from "./DichVuChatLuongCaoModel";
import DichVuChatLuongCaoApi from "../../../moduleApi/DichVuChatLuongCaoApi";
import EditorComponent from "../../../component/EditorComponent";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import MapComponent from "../../../component/MapComponent";

export default {
  components: {
    EditorComponent,
    MapComponent
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DichVuChatLuongCao",
        dataDefault: {
          roles: DataService.rolesInForm,
          listLanguage: DataService.Languages,
          listProvince: [],
          listDistrict: []
        },
        dataForm: MethodService.copyObject(DichVuChatLuongCaoModel.dataForm),
        validForm: DichVuChatLuongCaoModel.validForm,
        dialog: {},
        fileUploadOption: MethodService.copyObject(
          DichVuChatLuongCaoModel.dataFormOther.fileUploadOption
        ),
        dataPropMap: {
          fn_addLatLng: this.fn_addLatLng,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
          reload: 0
        }
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      if(this.mData.dataForm.ten.vi){
        this.mData.dataForm.ten.vi = this.mData.dataForm.ten.vi.trim();
      }
      if(this.mData.dataForm.ten.en){
        this.mData.dataForm.ten.en = this.mData.dataForm.ten.en.trim();
      }
      if(this.mData.dataForm.ly_do_khong_duyet){
        this.mData.dataForm.ly_do_khong_duyet = this.mData.dataForm.ly_do_khong_duyet.trim();
      }
      if(this.mData.dataForm.dia_diem.dia_diem){
        this.mData.dataForm.dia_diem.dia_diem = this.mData.dataForm.dia_diem.dia_diem.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (data.noi_dung.vi) {
            //replace http để lấy id ảnh
            data.noi_dung.vi = MethodService.replaceURLImage(data.noi_dung.vi);
          }
          if (data.noi_dung.en) {
            //replace http để lấy id ảnh
            data.noi_dung.en = MethodService.replaceURLImage(data.noi_dung.en);
          }
          if (!this.mData.dataPropMap.showMap) {
            data.dia_diem.lng = null;
            data.dia_diem.lat = null;
          } else {
            data.dia_diem.lng = this.mData.dataPropMap.lng;
            data.dia_diem.lat = this.mData.dataPropMap.lat;
          }
          if (this.aRole("HqsContributor")) {
            data.da_duyet = false;
          }
          if (type == "create") {
            await DichVuChatLuongCaoApi.create(data);
            this.fn_resetForm();
          }
          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            await DichVuChatLuongCaoApi.update(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        DichVuChatLuongCaoModel.dataForm
      );
      this.mData.dataForm.noi_dung.vi = "";
      this.mData.dataForm.noi_dung.en = "";
      this.mData.fileUploadOption = MethodService.copyObject(
        DichVuChatLuongCaoModel.dataFormOther.fileUploadOption
      );
      // this.mData.markdownOption = MethodService.copyObject(
      //   MethodService.markdownOption
      // );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DichVuChatLuongCaoApi.findByIdAllField(id);
      if (res.result.anh && res.result.anh.anh_dai_dien) {
        let data = {
          id: res.result.anh.anh_dai_dien,
          name: res.result.anh.anh_dai_dien,
          url: ExtensionService.urlImg + res.result.anh.anh_dai_dien
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }
      if (res.result.anh && res.result.anh.anh_bai_viet) {
        var data = [];
        for (let i = 0; i < res.result.anh.anh_bai_viet.length; i++) {
          let item = {
            id: res.result.anh.anh_bai_viet[i],
            name: res.result.anh.anh_bai_viet[i],
            url: ExtensionService.urlImg + res.result.anh.anh_bai_viet[i]
          };
          data.push(item);
        }

        this.mData.fileUploadOption.AnhBaiViet.fileList = data;
      }
      if (res.result.noi_dung.vi) {
        res.result.noi_dung.vi = MethodService.unreplaceURLImage(
          res.result.noi_dung.vi
        );
      }
      if (res.result.noi_dung.en) {
        res.result.noi_dung.en = MethodService.unreplaceURLImage(
          res.result.noi_dung.en
        );
      }

      if (
        res.result &&
        res.result.dia_diem &&
        res.result.dia_diem.lng &&
        res.result.dia_diem.lat
      ) {
        this.mData.dataPropMap.lng = res.result.dia_diem.lng;
        this.mData.dataPropMap.lat = res.result.dia_diem.lat;
        this.mData.dataPropMap.showMap = true;
      }

      if ((res.result && !res.result.dia_diem) || !res.result) {
        res.result["dia_diem"] = MethodService.copyObject(
          DichVuChatLuongCaoModel.dataForm.dia_diem
        );
      } else {
        if (res.result.dia_diem.province_id) {
          let resDistrict = await DistrictApi.list({
            limit: 1000,
            filters: `provinceId=${res.result.dia_diem.province_id}`
          });
          this.mData.dataDefault.listDistrict = resDistrict.result;
        }
      }

      this.mData.dataForm = res.result;
    },
    async fn_initDataDefault() {
      let provinces = await ProvinceApi.list({ limit: 1000 });
      this.mData.dataDefault.listProvince = provinces.result;
    },

    fn_changeTrangThaiDuyet(trangThai) {
      if (trangThai) {
        this.mData.dataForm.ly_do_khong_duyet = "";
      }
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh.anh_dai_dien = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "dichVuChatLuongCao")
        .then(res => {
          this.mData.dataForm.anh.anh_dai_dien = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhBaiViet(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.anh.anh_bai_viet = data;
    },
    fn_uploadChangeAnhBaiViet(file, fileList) {
      ExtensionService.upload(file, "dichVuChatLuongCao")
        .then(res => {
          this.mData.dataForm.anh.anh_bai_viet.push(res.result);
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhBaiViet.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhBaiViet(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhBaiViet.limit} file`
      );
    },
    fn_uploadPreviewAnhBaiViet(file) {
      this.mData.fileUploadOption.AnhBaiViet.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhBaiViet.dialogVisible = true;
    },
    async fn_changeProvince() {
      if (this.mData.dataForm.dia_diem.province_id) {
        let districts = await DistrictApi.list({
          limit: 1000,
          filters: `provinceId=${this.mData.dataForm.dia_diem.province_id}`
        });
        this.mData.dataDefault.listDistrict = districts.result;
        this.mData.dataForm.dia_diem.district_id = null;
      } else {
        this.mData.dataDefault.listDistrict = [];
        this.mData.dataForm.dia_diem.district_id = null;
      }
    }
  },

  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>